'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Select = require('./components/Select');

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @link https://racingpost.atlassian.net/browse/PB2-610
 */
exports.default = _Select2.default;


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-select/lib/js/index.js
// module id = 788
// module chunks = 1